import {
  WSCard,
  WSList,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { useHistory } from "react-router-dom";
import { useQueryInvoicesRowsSummary } from "../../../Invoicing/queries/useQueryInvoicesRowsSummary";
import { InvoiceRowStatus } from "../../../Invoicing/service";
import { WidgetPlatformBalance } from "../../../PlatformBalance/components/WidgetPlatformBalance";
import { DefaultPayoutMethod } from "../../../Settings/components/payout/DefaultPayoutMethod";
import { useRequirementsListQuery } from "../../../../query/requirements/queries/useRequirementsListQuery";
import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { useUserId } from "../../../../query/hooks/helpers";
import { useMemberProfile } from "../../../../query/users/queries";
import { useGetDashboardFocusedFeaturesContext } from "../../../../FocusedFeatures/Dashbaord/useGetDashboardFocusedFeaturesContext";
import { WSQueries } from "../../../../query/WSQuery";
import { selectorHasPayeeContextUser } from "../../../../shared/selectors/selectorHasPayeeContextUser";
import { EmptyComponent } from "../../../../shared/components/EmptyComponent";

export const SidePanel: React.FC = () => {
  const history = useHistory();
  const userId = useUserId();

  const queryMember = useMemberProfile(userId);
  const context = useGetDashboardFocusedFeaturesContext();

  const queryRequirements = useRequirementsListQuery({
    filter: {
      payeeId: userId,
      payerPayeeEngagementIds: {
        "!=": "null"
      },
      requirementType: RequirementType.PayoutMethod
    }
  });

  const queryInovicesRowsSummaryOutstanging = useQueryInvoicesRowsSummary({
    filter: {
      "labels.invoiceType": {
        "!=": "approvedInvoicesPayment"
      },
      status: {
        in: [InvoiceRowStatus.ActionRequired, InvoiceRowStatus.AwaitingClient]
      }
    }
  });

  const queryInovicesRowsSummaryDeposited = useQueryInvoicesRowsSummary({
    filter: {
      "labels.invoiceType": {
        "!=": "approvedInvoicesPayment"
      },
      status: InvoiceRowStatus.Deposited
    }
  });

  return (
    <WSQueries
      queries={{
        queryRequirements,
        queryInovicesRowsSummaryOutstanging,
        queryInovicesRowsSummaryDeposited,
        queryMember
      }}
      renderLoader={EmptyComponent}
      renderErrors={EmptyComponent}
    >
      {({
        queryRequirementsData,
        queryMemberData,
        queryInovicesRowsSummaryOutstangingData,
        queryInovicesRowsSummaryDepositedData
      }) => {
        const totalOutstandingInvoices =
          queryInovicesRowsSummaryOutstangingData.totalValue;

        const totalDepositedInvoices =
          queryInovicesRowsSummaryDepositedData.totalValue;

        const showOutstandingInvoicesPanel = !!totalOutstandingInvoices;
        const showDepositedInvoicesPanel = !!totalDepositedInvoices;

        const hasPayoutMethod =
          (selectorHasPayeeContextUser(queryMemberData.user) ||
            queryRequirementsData.some(
              requirement =>
                requirement.requirementType === RequirementType.PayoutMethod
            )) &&
          context?.access.hasPaymentsScope;

        const showHeader =
          showOutstandingInvoicesPanel ||
          showDepositedInvoicesPanel ||
          hasPayoutMethod;

        return (
          <>
            {showHeader ? <WSSectionToolbar title="Highlights" mb="L" /> : null}

            <WSList gap="XL">
              {showOutstandingInvoicesPanel ? (
                <WSCard
                  header={{
                    label: { text: "Outstanding invoices" },
                    value: {
                      value: formatMoney(
                        totalOutstandingInvoices,
                        queryInovicesRowsSummaryOutstanging.data?.currency ||
                          "USD"
                      )
                    }
                  }}
                  actions={{
                    alignment: "left",
                    buttons: [
                      {
                        kind: "Link",
                        rightIcon: "chevron-right",
                        onClick: () => {
                          history.push("/member/invoices/outstanding");
                        },
                        label: "See all outstanding invoices"
                      }
                    ]
                  }}
                />
              ) : null}

              {showDepositedInvoicesPanel ? (
                <WSCard
                  header={{
                    label: { text: "Invoices deposited" },
                    value: {
                      value: formatMoney(
                        totalDepositedInvoices,
                        queryInovicesRowsSummaryDeposited.data?.currency ||
                          "USD"
                      )
                    }
                  }}
                  actions={{
                    alignment: "left",
                    buttons: [
                      {
                        kind: "Link",
                        rightIcon: "chevron-right",
                        onClick: () => {
                          history.push("/member/invoices/deposited");
                        },
                        label: "See all deposited invoices"
                      }
                    ]
                  }}
                ></WSCard>
              ) : null}

              {hasPayoutMethod ? <DefaultPayoutMethod noDescription /> : null}

              <WidgetPlatformBalance />
            </WSList>
          </>
        );
      }}
    </WSQueries>
  );
};
